import type { ApiItem } from '@ui/shared/util-api';
import { MapItem } from '@ui/shared/util-map';
import type { Contact } from '@ui/shared/ui-detail-view';

export type FoundingMapItem = ApiItem & {
    uniqueId: string;

    iconPath: string;
    imagePath: string;
    thumbnailPath: string;

    addressAddition?: string;
    email?: string;
    fax?: string;
    contact?: Contact;
    website?: string;

    description?: string;
    targetGroups?: Array<string>;
    tags: Array<string>;
};

export class FoundingMapItemModel extends MapItem implements FoundingMapItem {

    public imagePath: string;
    public thumbnailPath: string;

    public addressAddition?: string;
    public email?: string;
    public fax?: string;
    public contact?: Contact;
    public website?: string;
    public tags: Array<string>;

    // room & contact point only
    public description?: string;
    public targetGroups?: Array<string>;

    constructor(mapItem: FoundingMapItem) {
        super(
            mapItem,
            mapItem.uniqueId,
        );

        this.iconPath = mapItem.iconPath;
        this.imagePath = mapItem.imagePath;
        this.thumbnailPath = mapItem.thumbnailPath;

        this.addressAddition = mapItem.addressAddition;
        this.email = mapItem.email;
        this.fax = mapItem.fax;
        this.contact = mapItem.contact;
        this.website = mapItem.website;
        this.description = mapItem.description;
        this.targetGroups = mapItem.targetGroups;
        this.tags = mapItem.tags;
    }
}
